import { useMemo } from "react";
import { useStableSearchParams } from "./useCustom";
import { createStableParams } from "@/lib/params";
import { clearUnwantedSearchParamsUrl } from "@/utils/urlManipulation";
import { ReadonlyURLSearchParams } from "next/navigation";

type StableParamsProps = {
  filtersToRemove?: string[];
  additionalParams?: { locationName?: string; administrativeLevel?: string };
};

export default function useStableParams({
  filtersToRemove = [],
  additionalParams = {},
}: StableParamsProps = {}) {
  const searchParams = useStableSearchParams();
  const cleanSearchParams = clearUnwantedSearchParamsUrl(
    searchParams,
    filtersToRemove,
    additionalParams
  );

  const stableParams = useMemo(() => {
    return createStableParams(cleanSearchParams as ReadonlyURLSearchParams);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cleanSearchParams]);
  return stableParams;
}
